import { render } from "./AppSectionBreadcrumb.vue?vue&type=template&id=427c59f0&scoped=true&ts=true&lang=pug"
import script from "./AppSectionBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./AppSectionBreadcrumb.vue?vue&type=script&lang=ts"

import "./AppSectionBreadcrumb.vue?vue&type=style&index=0&id=427c59f0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427c59f0"]])

export default __exports__